import { useCallback } from 'react';
import { useOtherSettings } from '@namespace/cms';
import { useHistory, useNavigate } from '@namespace/router';
import { useGetGameGoBackPath } from '../useGetGameGoBackPath';

export const useGetGameGoBack = (
  casinoLobbyUrl: string,
  providerServiceId?: string
) => {
  const { push } = useHistory();
  const navigate = useNavigate();
  const { gameGoBackPath, isPrevCasinoPathname } =
    useGetGameGoBackPath(casinoLobbyUrl);
  const { isGoBackInhanced, casinoProvidersWithBackToLobbyOnly } =
    useOtherSettings();

  const goBackClassic = useCallback(() => {
    push(gameGoBackPath);
  }, [gameGoBackPath, push]);

  const goBackInhanced = useCallback(
    (_?: unknown, backStepsNegativeNumber?: number) => {
      if (casinoProvidersWithBackToLobbyOnly.includes(providerServiceId)) {
        push(casinoLobbyUrl);
        return;
      }
      if (isPrevCasinoPathname) {
        navigate(backStepsNegativeNumber || -1);
        return;
      }
      push(gameGoBackPath);
    },
    [
      isPrevCasinoPathname,
      push,
      gameGoBackPath,
      casinoLobbyUrl,
      navigate,
      casinoProvidersWithBackToLobbyOnly,
      providerServiceId
    ]
  );

  return isGoBackInhanced ? goBackInhanced : goBackClassic;
};
